var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"section-title gray-400"},[_vm._t("default"),(_vm.notHaveSlot)?[_vm._v(" "+_vm._s(_vm.bilingual ? _vm.$t(_vm.title) : _vm.title)+" ")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }